module.exports = __webpack_public_path__ + "static/media/How-it-works.ad3ad746.svg";